export function isHomePage(location) {
  return /home/.test(location.pathname);
}

export function isLoginPage(location) {
  return /login/.test(location.pathname);
}
